import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const PendidikanService = {}

PendidikanService.getDataAll = function (token) {

    return fetch({
        url: '/ref/pendidikan',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PendidikanService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/pendidikan',
        method: 'get',
        params: {
            "id_pendidikan":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default PendidikanService;
